export default "__VITE_ASSET__CXvm5Hzi__"